/**
 * @license BCP
 * (c) 2015 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * License: MIT
 */
(function() {'use strict';

/**
 * @ngdoc module
 * @name customFilters
 * @description
 *
 * # customFilters
 *
 * The `customFilters` module contain additional filters.
 */
angular.module("customFilters", [])
  .constant("currencyMap", {
    "AED": { unit: "د.إ", name: "Emirati Dirham"},
    "AUD": { unit: "A$", name: "Australian Dollar"},
    "BGN": { unit: "лв", name: "Bulgarian Lev"},
    "BRL": { unit: "R$", name: "Brazilian Real"},
    "CAD": { unit: "CA$", name: "Canadian Dollar"},
    "CHF": { unit: "CHF", name: "Swiss Franc"},
    "CNY": { unit: "CN¥", name: "Chinese Yuan"},
    "CZK": { unit: "Kč", name: "Czech Koruna"},
    "DKK": { unit: "kr", name: "Danish Krone"},
    "EUR": { unit: "€", name: "Euro"},
    "GBP": { unit: "£", name: "British Pound"},
    "GHS": { unit: "GH₵", name: "Ghanaian cedi"},
    "HKD": { unit: "HK$", name: "Hong Kong Dollar"},
    "HRK": { unit: "kn", name: "Croatian Kuna"},
    "HUF": { unit: "Ft", name: "Hungarian Forint"},
    "IDR": { unit: "Rp", name: "Indonesian Rupiah"},
    "ILS": { unit: "₪", name: "Israeli New Sheqel"},
    "INR": { unit: "Rs.", name: "Indian Rupee"},
    "JPY": { unit: "¥", name: "Japanese Yen"},
    "KRW": { unit: "₩", name: "South Korean Won"},
    "LKR": { unit: "රු, Rs", name: "Sri Lankan Rupee"},
    "LTL": { unit: "Lt", name: "Lithuanian Litas"},
    "MXN": { unit: "MX$", name: "Mexican Peso"},
    "MYR": { unit: "RM", name: "Malaysian Ringgit"},
    "NOK": { unit: "kr", name: "Norwegian Krone"},
    "NZD": { unit: "NZ$", name: "New Zealand Dollar"},
    "PHP": { unit: "₱", name: "Philippine Peso"},
    "PLN": { unit: "zł", name: "Polish Zloty"},
    "RON": { unit: "lei", name: "Romanian Leu"},
    "RUB": { unit: "руб", name: "Russian Ruble"},
    "SEK": { unit: "kr", name: "Swedish Krona"},
    "SGD": { unit: "SG$", name: "Singapore Dollar"}, 
    "THB": { unit: "฿", name: "Thai Baht"},
    "TRY": { unit: "TRY", name: "Turkish Lira"}, 
    "USD": { unit: "$", name: "US Dollar"},
    "ZAR": { unit: "R", name: "South African Rand"},
  })
  .constant("activeGroups", [10,11,12,17])
  .filter("groupAccess", function (activeGroups) {
    return function (data) {
      if (angular.isArray(data)) {
        var result = [];
        data.forEach( function(item) {
          if (activeGroups.indexOf(item.id) != -1) {
            result.push(item);
          }
        });
        return result;
      } else {
        return data;
      }
    };
  })
  .filter("limitItems", function () {
    return function (data, limit, length) {
      if (angular.isArray(data)) {
        var calcLimit = limit || 5;
        if (length) {
          for (; calcLimit > 1; calcLimit--) {
            if (data.slice(0, calcLimit).join(', ').length <= length) {
              break;
            }
          }
        }
        return data.slice(0, calcLimit).join(', ') + (data.length > calcLimit ? ' ...' : '');
      } else {
        return data;
      }
    };
  })
  .filter("unique", function () {
    return function (data, propertyName, query) {
      if (angular.isArray(data) && angular.isString(propertyName)) {
        var results = [];
        var keys = [];
        var match = query.toString();
        for (var i = 0; i < data.length; i++) {
          if (angular.isDefined(data[i][propertyName])) {
            var val = data[i][propertyName].toString();
            if (angular.isUndefined(keys[val])) {
              if (angular.isUndefined(match)) {
                keys[val] = true;
                results.push(data[i]);
              } else {
                if (val === match) {
                  keys[val] = true;
                  results.unshift(data[i]);
                } else {
                  if (val.search(new RegExp(match, 'i')) != -1) {
                    keys[val] = true;
                    results.push(data[i]);
                  }
                }
              }
            }
          }
        }
        return results;
      } else {
        return data;
      }
    };
  })
  .filter("range", function ($filter) {
    return function (data, page, size) {
      if (angular.isArray(data) && angular.isNumber(page) && angular.isNumber(size)) {
        var start_index = (page - 1) * size;
        if (data.length < start_index) {
          return [];
        } else {
          return $filter("limitTo")(data.splice(start_index), size);
        }
      } else {
        return data;
      }
    };
  })
  .filter("totalItems", function () {
    return function (data) {
      if (angular.isArray(data)) {
        return data.length;
      } else {
        return data;
      }
    };
  })
  .filter('currencyMapper', function(currencyMap) {
    return function(input) {
      return angular.isDefined(currencyMap[input]) ? currencyMap[input].unit : input;
    };
  });

})();
